import LocationsTable from "../../components/tables/LocationsTable";

export default function Locations() {
  return (
    <div className="w-full min-h-full overflow-auto h-full">
      <LocationsTable defaultLimit={50} />
    </div>
  )
}